var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('h1',[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.main))]),_c('h2',[_vm._v(_vm._s(_vm.sub))]),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }